import React from "react";
import { Container, Typography, Box } from "@mui/material";

const Hakkimizda = () => {
    return (
        <Container maxWidth="md" sx={{ py: 5 }}>
            <Box textAlign="center" mb={4}>
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                    Hakkımızda
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                    "Müşteri odaklı hizmet anlayışımız ile güvenilir ve şeffaf muhasebe hizmetleri sunuyoruz."
                </Typography>
            </Box>
            <Typography variant="body1" paragraph>
                Silivri'de hizmet veren Muhasebe ve Mali Müşavirlik Ofisimiz, müşterilerimize profesyonel, etik kurallara uygun ve kaliteli hizmetler sunmayı amaçlar.
                Finansal danışmanlık, vergi yönetimi, şirket kuruluşları ve muhasebe süreçlerinde uzman ekibimizle yanınızdayız.
            </Typography>
            <Typography variant="body1" paragraph>
                İstanbul/Silivri merkezli olarak, 2024 yılından bu yana Serbest Muhasebeci Mali Müşavirlik hizmetleri sunmaktayız.
                Mesleğimizin temel taşları olan güvenilirlik ve yenilikçiliği, hizmet anlayışımızın merkezine yerleştirdik.
                Sürekli değişen mevzuatı yakından takip ediyor, gelişen teknolojileri muhasebe süreçlerine entegre ederek işimizi her zaman güncel tutuyoruz.
            </Typography>
            <Typography variant="body1" paragraph>
                Müşterilerimizin beklenti ve ihtiyaçlarını anlamak bizim için en önemli önceliklerden biri. Kuruluşumuzdan itibaren, geri bildirimleri dikkatle dinleyerek hizmet kalitemizi sürekli iyileştirdik. Bu yaklaşımımız, olası eksiklikleri hızla gidererek daha etkin çözümler sunmamızı sağladı.
            </Typography>
            <Typography variant="body1" paragraph>
                Bugün, müşteri odaklı ve güvenilir hizmet anlayışımız sayesinde geniş bir müşteri portföyüne sahibiz. En büyük gururumuz ise bizimle çalışan herkesin memnuniyetini kazanarak, güçlü referanslara sahip olmamızdır.
            </Typography>
            <Typography variant="body1" paragraph>
                Sizi de ofisimizde ağırlamaktan mutluluk duyarız.
            </Typography>
        </Container>
    );
};

export default Hakkimizda;
